// PrivacyPolicy.js
import React from 'react';
import '../style/PrivacyPolicy.css'; // We'll create this CSS

export default function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <h1 className="privacy-title">Privacy Policy</h1>
        <p className="privacy-updated"><strong>Last Updated:</strong> April 20, 2025</p>

        <p>
          Welcome to <span className="brand">CarsChalao</span> — your trusted platform for automotive news, reviews, and information.
          Protecting your privacy is our top priority. This Privacy Policy explains what information we collect, how we use it,
          and your choices when using <a href="https://carschalao.com" className="privacy-link">https://carschalao.com</a>.
        </p>

        <h2 className="privacy-subtitle">Who We Are</h2>
        <p>
          Our website: <a href="https://carschalao.com" className="privacy-link">https://carschalao.com</a><br/>
          CarsChalao is committed to delivering information responsibly while respecting user privacy.
        </p>
        <p>If you have questions, contact us: 📧 <a href="mailto:info@carschalao.com" className="privacy-link">info@carschalao.com</a></p>

        <h2 className="privacy-subtitle">Comments</h2>
        <p>
          When visitors leave comments, we collect the data shown in the comments form, plus IP address and browser info to detect spam.
        </p>
        <p>
          An anonymized string of your email (hash) may be sent to Gravatar. View the Gravatar Privacy Policy <a href="https://automattic.com/privacy/" className="privacy-link">here</a>.
        </p>

        <h2 className="privacy-subtitle">Media & Cookies</h2>
        <p>
          Avoid uploading images with embedded location data (EXIF GPS). We use cookies to improve your experience:
        </p>
        <ul>
          <li><strong>Comment Cookies:</strong> Save your details for one year.</li>
          <li><strong>Login Cookies:</strong> Keep login & preferences for 2 days to 2 weeks.</li>
          <li><strong>Editor Cookies:</strong> Save post IDs for one day.</li>
        </ul>

        <h2 className="privacy-subtitle">Embedded Content</h2>
        <p>
          Articles may include embedded content (videos, social posts, etc.) that behaves as if you visited the external website.
        </p>

        <h2 className="privacy-subtitle">Analytics & Advertising</h2>
        <p>
          We use Google Analytics & AdSense to analyze usage and show relevant ads. You can opt-out anytime: <a href="https://adssettings.google.com/" className="privacy-link">Ad Settings</a>.
        </p>

        <h2 className="privacy-subtitle">Data Sharing & Retention</h2>
        <p>
          We do not sell personal data. Shared only with trusted services or legal authorities if required.
        </p>
        <p>
          Comments & metadata are retained indefinitely. Registered users can edit or delete their personal data anytime.
        </p>

        <h2 className="privacy-subtitle">Your Rights</h2>
        <ul>
          <li>Request export of your personal data.</li>
          <li>Request deletion of personal data (except where legally required).</li>
        </ul>
        <p>Email: <a href="mailto:info@carschalao.com" className="privacy-link">info@carschalao.com</a> with subject: "Privacy Data Request".</p>

        <h2 className="privacy-subtitle">Data Security & Updates</h2>
        <p>
          We use SSL encryption and best practices. Updates to this policy will appear here with the revised date.
        </p>

        <h2 className="privacy-subtitle">Contact Us</h2>
        <p>
          📧 <a href="mailto:info@carschalao.com" className="privacy-link">info@carschalao.com</a><br/>
          🌐 <a href="https://carschalao.com" className="privacy-link">https://carschalao.com</a>
        </p>
      </div>
    </div>
  );
}
